import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './ChangePass.module.scss';
import CardAboutMe from '../../components/card-about-me';
import { Row, Form, Modal } from 'antd';
// import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import OTPModal from '~/components/form-otp';
import SuccessChangePassModal from '~/components/form-success-change-pass';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import authAPI from '~/api/AuthAPI';
import { auth } from '~/service/firebase';
import firebase from '../../service/firebase';
import md5 from 'md5';
import OtpInput from 'react-otp-input';
import styled from 'styled-components';
import config from '~/config';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);

const InputData = styled.div`
    .ant-form-item-explain-error {
        margin-left: 7px;
    }
`;

const ChangePass = () => {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.user.userInfo);
    const [isShowOTPModal, setIsShowOTPModal] = useState(false);
    const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);

    const [dataChange, setDataChange] = useState({ old_password: '', new_password: '', verify_password: '' });

    //    Change pass
    const [errChange, setErrChange] = useState();
    const [formPass] = Form.useForm();
    const defaultValuesPass = {
        old_password: '',
        new_password: '',
        verify_password: '',
    };

    const onChangeOldPassword = (value) => {
        setDataChange({ ...dataChange, old_password: value });
    };
    const onChangeNewPassword = (value) => {
        setDataChange({ ...dataChange, new_password: value });
    };
    // const onChangeVerifyPassword = (value) => {
    //     setDataChange({ ...dataChange, verify_password: value });
    // };

    const onFinishChangePass = async () => {
        try {
            const dataSend = {
                old_password: md5(dataChange.old_password),
                type: 'CHECK',
            };

            const res = await authAPI.changePassAPI(dataSend);
            if (res.code === 200) {
                sendOTPToPhone(userInfo?.phone);
                setIsShowOTPModal(true);
            }
            setErrChange('');
        } catch (err) {
            console.log(err);
            if (err.message) {
                setErrChange(err.message);
            }
        }
    };

    // Verify OTP
    const [formOTP] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [errOtp, setErrOtp] = useState('');
    const [countErr, setCountErr] = useState(0);
    const defaultValuesOTP = {
        otp: null,
    };
    formOTP.setFieldsValue(defaultValuesOTP);
    const onFinishOTP = () => {
        try {
            if (otp.toString().length !== 6) {
                setErrOtp('Please enter OTP code');
            } else {
                if (otp?.length === 6) {
                    window.confirmationResult
                        .confirm(otp)
                        .then((confirmationResult) => {
                            //eslint-disable-next-line
                            // const { accessToken, phoneNumber } = confirmationResult.user._delegate;
                            // let phone = phoneNumber;
                            // if (phone.startsWith('+84')) phone = `0${phone.substring(3)}`;
                            const dataSend = {
                                old_password: md5(dataChange.old_password),
                                new_password: md5(dataChange.new_password),
                                type: 'CHANGE',
                            };
                            authAPI.changePassAPI(dataSend);
                            setIsShowOTPModal(false);
                            setIsShowSuccessModal(true);
                            setOtp('');
                            setErrChange('');
                            setDataChange(defaultValuesPass);
                            formPass.setFieldsValue(defaultValuesPass);
                        })
                        .catch((err) => {
                            const errorFirebase = err.toString().split('/')[1].slice(0, -2);

                            if (errorFirebase === 'invalid-verification-code') {
                                setErrOtp('Invalid OTP code');
                            }
                            const count = countErr + 1;
                            setCountErr(count);
                            if (count === 3) {
                                sendOTPToPhone(userInfo?.phone);
                                setCountErr(0);
                                setErrOtp('OTP code has just been sent back');
                            }
                        });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };
    const onChangeOtp = (val) => {
        setOtp(val);
        if (!val) {
            setErrOtp('Please enter OTP code');
        } else {
            setErrOtp('');
        }
    };

    const sendOTPToPhone = async (phone) => {
        if (phone.startsWith('0')) phone = `+84${phone.substring(1)}`;
        try {
            const appVerifier = window.recaptchaVerifier;
            auth.signInWithPhoneNumber(phone, appVerifier)
                .then((confirmationResult) => {
                    window.confirmationResult = confirmationResult;
                })
                .catch((err) => {
                    const errorFirebaseCheck = err.toString().split('/');
                    if (
                        errorFirebaseCheck[0] === 'Error: reCAPTCHA has already been rendered in this element' ||
                        errorFirebaseCheck[1] === 'too-many-requests).'
                    ) {
                        setErrOtp('Sending OTP exceeded the allowed limit, please try again later');
                    }
                });
        } catch (error) {
            console.log('🚀 ~ file: index.js ~ line 90 ~ sendOTPToPhone ~ error', error);
        }
    };

    useEffect(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            size: 'invisible',
            callback: function (response) {},
            defaultCountry: 'VN',
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThayDoiMatKhau');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 0, children: 1 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Change the password
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        <Row align="middle" style={{ height: '550px' }}>
                            <div className={cx('form_container')}>
                                <Form onFinish={onFinishChangePass} form={formPass}>
                                    <Form.Item>
                                        <Row justify="center" className={cx('name_page')}>
                                            Change Password
                                        </Row>
                                    </Form.Item>
                                    <Form.Item>
                                        <Row justify="center" className={cx('bio')}>
                                            <div>
                                                For account security, please do not share your password with others
                                            </div>
                                            <div>
                                                Friend
                                                <span onClick={() => navigate(config.routes.forgotPassword)}>
                                                    Forgot password?
                                                </span>
                                            </div>
                                        </Row>
                                    </Form.Item>
                                    <Row justify="center" className={cx('err')}>
                                        {errChange}
                                    </Row>
                                    <span className={cx('title_input')}>Current password:</span>
                                    <InputData>
                                        <Form.Item
                                            name="old_password"
                                            id="old_password"
                                            rules={[
                                                { required: true, message: 'Please enter your current password' },
                                                { min: 6, message: 'Please enter your current password' },
                                            ]}
                                            style={{ width: '100%' }}
                                        >
                                            <OtpInput
                                                name="old_password"
                                                value={dataChange?.password}
                                                shouldAutoFocus={true}
                                                onChange={onChangeOldPassword}
                                                numInputs={6}
                                                className={cx('otp_login')}
                                                isInputNum={true}
                                                isInputSecure={true}
                                            />
                                        </Form.Item>
                                    </InputData>
                                    <span className={cx('title_input')}>New password:</span>
                                    <InputData>
                                        <Form.Item
                                            name="new_password"
                                            id="new_password"
                                            rules={[
                                                { required: true, message: 'Please enter a new password' },
                                                { min: 6, message: 'Please enter a new password' },
                                            ]}
                                        >
                                            <OtpInput
                                                name="new_password"
                                                value={dataChange?.new_password}
                                                shouldAutoFocus={true}
                                                onChange={onChangeNewPassword}
                                                numInputs={6}
                                                className={cx('otp_login')}
                                                isInputNum={true}
                                                isInputSecure={true}
                                            />
                                        </Form.Item>
                                    </InputData>
                                    {/* <span className={cx('title_input')}>Confirm password:</span>
                                    <InputData>
                                        <Form.Item
                                            name="verify_password"
                                            rules={[
                                                { required: true, message: 'Please enter new password confirmation' },
                                                {
                                                    message: 'Incorrect password confirmation',
                                                    validator: (_, value) => {
                                                        if (dataChange?.new_password !== value && value) {
                                                            return Promise.reject('Some message here');
                                                        } else {
                                                            return Promise.resolve();
                                                        }
                                                    },
                                                },
                                            ]}
                                        >
                                            <OtpInput
                                                name="verify_password"
                                                value={dataChange?.verify_password}
                                                shouldAutoFocus={true}
                                                onChange={onChangeVerifyPassword}
                                                numInputs={6}
                                                className={cx('otp_login')}
                                                isInputNum={true}
                                            />
                                        </Form.Item>
                                    </InputData> */}
                                    <Form.Item style={{ marginTop: '30px' }}>
                                        <button htmlType="submit" className={cx('btn_login')}>
                                            Confirm
                                        </button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
            <div id="recaptcha-container" visibility="hidden" data-size="invisible"></div>
            {isShowOTPModal && (
                <Modal
                    centered
                    visible={isShowOTPModal}
                    onCancel={() => {
                        setIsShowOTPModal(false);
                        formOTP.setFieldsValue(defaultValuesOTP);
                        setOtp('');
                    }}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <OTPModal
                            formOTP={formOTP}
                            onFinishOTP={onFinishOTP}
                            otp={otp}
                            onChangeOtp={onChangeOtp}
                            errOtp={errOtp}
                            numPhone={userInfo?.phone}
                        />
                    </div>
                </Modal>
            )}
            {isShowSuccessModal && (
                <Modal
                    centered
                    visible={isShowSuccessModal}
                    onCancel={() => setIsShowSuccessModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <SuccessChangePassModal />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default ChangePass;
